(function($, Cobalt, undefined) {
    var fixTransformForAxis = function(axis) {
        if (!axis) {
            return;
        }
        var transformType = axis.transformType;
        delete axis.transformType;
        if (transformType == "Linear") {
            // don't do anything
        } else if (transformType == "Logarithmic") {
            axis.transform = function(v) { return Math.log(v); };
            axis.inverseTransform = function(v) { return Math.exp(v); };
        } else if (transformType == "Logarithmic10") {
            axis.transform = function(v) { return Math.log(v) / Math.LN2; };
            axis.inverseTransform = function(v) { return Math.pow(2, v); };
        } else if (transformType == "Logarithmic10") {
            axis.transform = function(v) { return Math.log(v) / Math.LN10; };
            axis.inverseTransform = function(v) { return Math.pow(10, v); };
        } else if (transformType == "Exponential") {
            axis.transform = function(v) { return Math.exp(v); };
            axis.inverseTransform = function(v) { return Math.log(v); };
        } else if (transformType == "Exponential2") {
            axis.transform = function(v) { return Math.pow(2, v); };
            axis.inverseTransform = function(v) { return Math.log(v) / Math.LN2; };
        } else if (transformType == "Exponential10") {
            axis.transform = function(v) { return Math.pow(10, v); };
            axis.inverseTransform = function(v) { return Math.log(v) / Math.LN10; };
        }
    };

    Cobalt.flot = {
        fixOptions: function(options) {
            fixTransformForAxis(options.xaxis);
            fixTransformForAxis(options.yaxis);
            return options;
        }
    };
})(jQuery, Cobalt);



// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.flot.js